var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "form-field",
      class: {
        "form-field--textarea": _vm.type === "textarea",
        "form-field--file": _vm.type === "file",
        "form-field--has-value": _vm.hasValue,
        "form-field--focus": _vm.isFocussed
      }
    },
    [
      _c(
        "div",
        { staticClass: "form-field__inner" },
        [
          _c(
            "label",
            {
              staticClass: "form-field__label",
              class: ["form-field__label--" + _vm.type],
              attrs: { for: "input-" + _vm.name }
            },
            [
              _c("span", [
                _vm._v(_vm._s(_vm.required ? _vm.label + "*" : _vm.label))
              ])
            ]
          ),
          _vm._v(" "),
          _vm.type == "textarea"
            ? _c("textarea-autosize", {
                staticClass: "form-field__input form-field__input--textarea",
                attrs: {
                  id: "input-" + _vm.name,
                  name: _vm.name,
                  placeholder: _vm.placeholder,
                  required: _vm.required
                },
                on: {
                  change: function($event) {
                    return _vm.$emit("input", $event.target.value)
                  }
                },
                nativeOn: {
                  focus: function($event) {
                    return _vm.onFocus()
                  },
                  blur: function($event) {
                    return _vm.onBlur()
                  }
                },
                model: {
                  value: _vm.value,
                  callback: function($$v) {
                    _vm.value = $$v
                  },
                  expression: "value"
                }
              })
            : _vm.type == "file"
            ? _c("div", { staticClass: "form-field__file-input" }, [
                _c("input", {
                  staticClass: "wpcf7-form-control wpcf7-file input-file",
                  attrs: {
                    type: "file",
                    id: "input-" + _vm.name,
                    name: _vm.name,
                    size: "40",
                    accept: ".pdf,.zip,.doc,.docx",
                    "aria-invalid": "false"
                  },
                  on: {
                    focus: function($event) {
                      return _vm.onFocus()
                    },
                    blur: function($event) {
                      return _vm.onBlur()
                    },
                    change: _vm.onChangeFile
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "form-field__file-input__button" }, [
                  _vm._v(_vm._s(_vm.value.length ? _vm.value : "Upload"))
                ])
              ])
            : _vm.type === "checkbox"
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.value,
                    expression: "value"
                  }
                ],
                staticClass: "form-field__input",
                attrs: {
                  id: "input-" + _vm.name,
                  name: _vm.name,
                  placeholder: _vm.placeholder,
                  required: _vm.required,
                  type: "checkbox"
                },
                domProps: {
                  checked: Array.isArray(_vm.value)
                    ? _vm._i(_vm.value, null) > -1
                    : _vm.value
                },
                on: {
                  focus: function($event) {
                    return _vm.onFocus()
                  },
                  blur: function($event) {
                    return _vm.onBlur()
                  },
                  change: [
                    function($event) {
                      var $$a = _vm.value,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.value = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.value = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.value = $$c
                      }
                    },
                    function($event) {
                      return _vm.$emit("input", $event.target.value)
                    }
                  ]
                }
              })
            : _vm.type === "radio"
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.value,
                    expression: "value"
                  }
                ],
                staticClass: "form-field__input",
                attrs: {
                  id: "input-" + _vm.name,
                  name: _vm.name,
                  placeholder: _vm.placeholder,
                  required: _vm.required,
                  type: "radio"
                },
                domProps: { checked: _vm._q(_vm.value, null) },
                on: {
                  focus: function($event) {
                    return _vm.onFocus()
                  },
                  blur: function($event) {
                    return _vm.onBlur()
                  },
                  change: [
                    function($event) {
                      _vm.value = null
                    },
                    function($event) {
                      return _vm.$emit("input", $event.target.value)
                    }
                  ]
                }
              })
            : _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.value,
                    expression: "value"
                  }
                ],
                staticClass: "form-field__input",
                attrs: {
                  id: "input-" + _vm.name,
                  name: _vm.name,
                  placeholder: _vm.placeholder,
                  required: _vm.required,
                  type: _vm.type
                },
                domProps: { value: _vm.value },
                on: {
                  focus: function($event) {
                    return _vm.onFocus()
                  },
                  blur: function($event) {
                    return _vm.onBlur()
                  },
                  change: function($event) {
                    return _vm.$emit("input", $event.target.value)
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.value = $event.target.value
                  }
                }
              })
        ],
        1
      ),
      _vm._v(" "),
      _vm.isShowingWarning
        ? _c("p", { staticClass: "form-field__warning" }, [
            _vm._v("This field is required.")
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/omer/Projects/Arcadian/embl/wp-content/themes/embl/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/omer/Projects/Arcadian/embl/wp-content/themes/embl/node_modules/vue-loader/lib?{}!./scripts/vue/TextInput.vue?vue&type=template&id=af54efce&
// module id = 87
// module chunks = 0